import { Skeleton } from '@/components/common/Skeleton/Skeleton';
export function JobListItemSkeleton() {
  return (
    <div className="flex flex-col gap-4 p-4 w-full">
      <div className="flex flex-row gap-4">
        <Skeleton className="w-[167px] relative aspect-[3/2] rounded-small overflow-hidden" />
        <div className="flex flex-col gap-2 flex-grow">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-6 w-40" />
        </div>
      </div>

      <div className="flex flex-col gap-1">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
      </div>

      <Skeleton className="h-8 w-full" />
      <Skeleton className="h-10 w-full" />
    </div>
  );
}
